import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { getFBToken } from "../firebase/utils";

const SERVER_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const adminApi = axios.create({
  baseURL: `${SERVER_URL}/admin`,
  timeout: 45000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

adminApi.interceptors.request.use(
  async function (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> {
    const appToken = await getFBToken();

    config.headers.Authorization = appToken;

    return config;
  },
  function (error: AxiosError) {
    console.warn(error);
    return Promise.reject(error);
  }
);
